import { useI18n } from "vue-i18n";
import html_iway from "./template.iway.html?raw";
import ErrorMessage from "../../Shared/ErrorMessage";
import { computed, defineAsyncComponent, inject, onMounted, watch } from "vue";
import { configsProviderKey, type ConfigsNavigationPath } from "../../../infrastructure/configs_provider";
import { useRouter, useRoute } from "vue-router";
import ConfigsNavigation from "../ConfigsNavigation";
import Cart from "../../Shared/Cart";

// Eine Bestellung braucht immer nur eine Teilmenge dieser vier Vertikalen
// (siehe ConfigsProvider.configsPathes) -> jeweils erst laden, wenn sie sichtbar wird
const ConfigsAccess = defineAsyncComponent(() => import("../ConfigsAccess"));
const ConfigsMobile = defineAsyncComponent(() => import("../ConfigsMobile"));
const ConfigsPhone = defineAsyncComponent(() => import("../ConfigsPhone"));
const ConfigsTv = defineAsyncComponent(() => import("../ConfigsTv"));

const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}
export default {
  template: html,
  components: { ErrorMessage, ConfigsAccess, ConfigsMobile, ConfigsPhone, ConfigsTv, ConfigsNavigation, Cart },
  setup() {
    // Injections
    const { t } = useI18n();
    const router = useRouter();
    const route = useRoute();
    const configsProvider = inject(configsProviderKey) ;
    const configsPathes = computed<ConfigsNavigationPath[]>(() => {
      return configsProvider?.configsPathes.value ?? [];
    })
    const currentPath = computed(() => {
      const currentIndex = configsPathes.value.findIndex((p) => p.path == route.path);
      const current = configsPathes.value[currentIndex];
      return current;
    })

    const currentPathString = computed(() => currentPath.value?.path || "")

    const next = function(){
      const currentIndex = configsPathes.value.findIndex((p) => p.path == route.path);
      const next = configsPathes.value[currentIndex + 1] 
      if (next){
        router.push(next.path);
      } else {
        router.push("/configs");
      }
    }

    const handleOptionsPath = () => {
      if ("/configs" == route.path){
        const first = configsPathes.value[0];
        if (first){
          router.push(first.path);
        } else {
          router.push("/configs")
        }
      }
    }

    onMounted(() => {
      // /options is just the container -> move to the first option page
      handleOptionsPath();
    })

    watch(() => route.path, () => {
      handleOptionsPath();
    })
    return {
      t,
      currentPathString,
      next
    };
  },
};
